<template>
  <md-progress-bar
    v-if="loading"
    md-mode="query"
  />
  <md-autocomplete
    v-else
    v-model="input"
    :md-options="options"
    :md-fuzzy-search="false"
    @md-selected="updateFilter"
  >
    <label>Server Bundles</label>
  </md-autocomplete>
</template>

<script>
export default {
    name: "ServerBundlesFilter",
    data: () => {
        return {
            input: "",
            options: [],
            loading: true
        };
    },
    mounted() {
        this.fetchServerBundles();
    },
    methods: {
        fetchServerBundles() {
            this.loading = true;
            this.$http.get("/v1/admin/node/server-bundles").then(
                res => {
                    this.options = res.data.server_bundles.map(bundle => bundle.name);
                    this.loading = false;
                },
                err => {
                    console.error(err);
                    this.loading = false;
                },
            );
        },
        updateFilter(value) {
            this.$emit("onBundlesFilterUpdate", value);
        },
    }
};
</script>
